import React from 'react'
import { TokenPairImage as UIKitTokenPairImage, TokenPairImageProps as UIKitTokenPairImageProps } from 'uikit'
import { Token } from 'config/constants/types'
import { getPngImageUrlFromToken } from 'utils'

interface TokenPairImageProps extends Omit<UIKitTokenPairImageProps, 'primarySrc' | 'secondarySrc'> {
  primaryToken: Token
  secondaryToken: Token
}

const TokenPairImage: React.FC<TokenPairImageProps> = ({ primaryToken, secondaryToken, ...props }) => {
  return (
    <UIKitTokenPairImage
      primarySrc={getPngImageUrlFromToken(primaryToken)}
      secondarySrc={getPngImageUrlFromToken(secondaryToken)}
      {...props}
    />
  )
}

export default TokenPairImage
